<p>{{ 'agent:panel.chat.copy.header' | translate }}</p>
<ul>
  <li *ngFor="let room of activeRoomList" title="{{ copyItemLabel(room) }}">
    <button mat-menu-item (click)="onCopyToRoom(room.roomId)">
      <span class="text">{{ copyItemLabel(room) }}</span>
      <span class="nodisplay">{{ 'agent:panel.chat.copy.new.specific_ask' | translate }} {{ copyItemLabel(room) }}</span>
    </button>
  </li>
  <li *ngIf="chatAssistanceService.canCopyToNewRoom()" title="{{ 'agent:panel.chat.copy.new.ask' | translate }}">
    <button mat-menu-item (click)="onCopyToRoom()">
      <span class="text">{{ 'agent:panel.chat.copy.new.title' | translate }}</span>
      <span class="nodisplay">{{ 'agent:panel.chat.copy.new.ask' | translate }}</span>
    </button>
  </li>
</ul>
